<template>
  <div class="about-page">
    <kinesis-container event="scroll" class="container">
      <kinesis-element :cycle="1" :strength="10">
        <div class="kinesis kinesis-first">
          <img src="../assets/images/kinesis-first.svg" />
        </div>
      </kinesis-element>
      <kinesis-element :cycle="1" :strength="10">
        <div class="kinesis kinesis-second">
          <img src="../assets/images/kinesis-second.svg" />
        </div>
      </kinesis-element>
      <kinesis-element :cycle="1" :strength="10">
        <div class="kinesis kinesis-third">
          <img src="../assets/images/kinesis-third.svg" />
        </div>
      </kinesis-element>
      <kinesis-element :cycle="1" :strength="10">
        <div class="kinesis kinesis-fourth">
          <img src="../assets/images/kinesis-fourth.svg" />
        </div>
      </kinesis-element>
      <kinesis-element :cycle="1" :strength="10">
        <div class="kinesis kinesis-five">
          <img src="../assets/images/kinesis-five.svg" />
        </div>
      </kinesis-element>
      <div class="about-page__wrapper about-page__wrapper-partners">
        <h1 class="text-rothek font-104 mb-60">Новости</h1>
        <div v-if="newsList && newsList.length > 0" class="news-list">
          <div 
            v-for="(newsItem, index) in newsList" 
            :key="index" 
            class="news-item mb-30"
          >
            <div class="fill bg-blue">
              <h2 class="text-rothek font-36 mb-20">
                <a :href="newsItem.link" target="_blank" class="color-white news-title-link">
                  {{ newsItem.title }}
                </a>
              </h2>
              <div v-if="newsItem.link" class="news-link">
                <a :href="newsItem.link" target="_blank" class="color-white">Читать далее →</a>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="newsList && newsList.length === 0" class="text-center">
          <p class="text-rothek font-24">Новостей пока нет</p>
        </div>
      </div>
      <feedback fill="orange" />
    </kinesis-container>
  </div>
</template>

<script>
import Feedback from "../components/Feedback.vue";
import axios from "axios";
export default {
  name: "PartnersPage",
  components: {Feedback},
  data() {
    return {
      newsList: null
    }
  },
  async mounted() {
    try {
      const response = await axios.get('documents/2');
      const document = response.data;
      
      if (document && document.text) {
        this.newsList = this.parseNewsFromHTML(document.text);
      } else {
        this.newsList = [];
      }
    } catch (error) {
      console.error('Error loading news:', error);
      this.newsList = [];
    }
  },
  methods: {
    parseNewsFromHTML(htmlText) {
      const newsList = [];
      
      // Создаем временный DOM элемент для парсинга HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlText;
      
      // Ищем все элементы h2 с ссылками внутри
      const h2Elements = tempDiv.querySelectorAll('h2');
      
      h2Elements.forEach((h2) => {
        const link = h2.querySelector('a');
        if (link) {
          const title = link.textContent.trim();
          const href = link.getAttribute('href');
          
          if (title && href) {
            newsList.push({
              title: title,
              link: href
            });
          }
        }
      });
      
      return newsList;
    }
  }
}
</script>

<style scoped>
.news-list {
  width: 100%;
}

.news-item {
  width: 100%;
}

.news-title-link {
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.news-title-link:hover {
  opacity: 0.8;
}

.news-link {
  margin-top: 20px;
}

.news-link a {
  text-decoration: none;
  font-weight: 500;
  transition: opacity 0.3s ease;
}

.news-link a:hover {
  opacity: 0.8;
}
</style>